<template>
   <v-container :fill-height="!$vuetify.breakpoint.xsOnly" 
   v-bind:style="{ backgroundColor:'#ffffff'}"
   :style="{
  minHeight: $vuetify.breakpoint.xsOnly ? 'calc(100vh - 300px)' : 
  $vuetify.breakpoint.smOnly ? 'calc(100vh - 300px)' :
  'calc(100vh - 150px)'
}"
   >
      <v-row class="mb-16 ml-4 mr-4" justify="center" v-bind:style="{ align:'center'}" :class="{'mt-16': !$vuetify.breakpoint.smAndDown,'pl-8': $vuetify.breakpoint.smAndDown ,'pr-8': $vuetify.breakpoint.smAndDown}" >
        <v-col class="order-2 order-md-1 pa-0 pa-sm-16 pa-md-10 mt-sm-n12" justify="center" cols="12" xl="8" lg="8" md="8" sm="12" xs="12" v-bind:style="{alignContent: 'center',align:'center' }">
    <v-card  class="mx-auto my-6 pa-4"  :elevation="0" style="border-radius:30px;border:0px solid black;" >
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <!-- #205295 -->
    <v-card-title class="justify-center" style="color: #000000;"><h3>{{this.lg_header_contract.manageyourdatarights}}</h3></v-card-title>
    <v-card-title class="justify-center font-weight-regular mt-n6"><h6>{{this.lg_header_contract.submanageyourdatarights}}</h6></v-card-title>
     <!-- <v-row class="" justify="center" >
          <v-col align="center" justify="center"  cols="12" xl="3" lg="3" md="3" sm="12" xs="12">
            <v-card-title ><h5 class="justify-center font-weight-regular mt-n4">{{this.lg_header_contract.personalinformation}}</h5></v-card-title>
          </v-col>
     <v-col align="left" justify="left"  cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
          </v-col>
    </v-row> -->
<v-form @submit.prevent="sendEmail" v-model="valid" ref="form" class="custom-padding-form ">
         <v-row class="" justify="center" >
      <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <!-- outlined -->
           <div class="custom-field">
    <label class="custom-label">
       {{ lg_header_contract.placeholdername }}<span class="required-star">*</span>
    </label>
    <!--  prepend-inner-icon="mdi-account-outline"
      :label="lg_header_contract.placeholdername"
      :placeholder="lg_header_contract.placeholdername" -->
        <v-text-field
            v-model="form.name"
            :rules="nameRules"
            required
            outlined
            dense
            class="custom-input"
          ></v-text-field>
           </div>
      </v-col>
       </v-row>

        <v-row class="" justify="center" >
          <!-- :hint="lg_header_contract.email_hint" persistent-hint class="red-hint" -->
      <v-col align="center" justify="center" cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
                   <div class="custom-field mt-n6">
    <label class="custom-label">
       {{ lg_header_contract.email_contact }}<span class="required-star">*</span>
    </label>
                <!-- :label="lg_header_contract.email_contact"
            :placeholder="lg_header_contract.email_contact"
            prepend-inner-icon="mdi-email-outline" -->
       <v-text-field
            class="custom-input"
            v-model="form.email"
             :rules="emailRules"
             required
            dense
            outlined
          ></v-text-field>
           </div>
      </v-col>
      <v-col align="center" justify="center" cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
         <div class="custom-field mt-n6">
    <label class="custom-label">
       {{ lg_header_contract.phone_number }}
       <!-- <span class="required-star">*</span> -->
    </label>
                <!-- :label="lg_header_contract.phone_number"
            :placeholder="lg_header_contract.phone_number"
            prepend-inner-icon="mdi-phone" -->
            <!-- :rules="phoneRules" -->
          <v-text-field
            class="custom-input"
            v-model="form.phone"
            dense
            outlined
          ></v-text-field>
          </div>
      </v-col>
    </v-row>

      <v-row  justify="center" >
     <v-col align="center" justify="center" cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
               <div class="custom-field mt-n6">
    <label class="custom-label">
       {{ lg_header_contract.message }}<span class="required-star">*</span>
    </label>
                <!-- :label="lg_header_contract.message"
            :placeholder="lg_header_contract.message"
             prepend-inner-icon="mdi-message-text-outline" -->
       <v-textarea
            class="custom-input"
            v-model="form.message"
             :rules="messageRules"
             required
            outlined
            dense
            auto-grow
      full-width
      single-line
    ></v-textarea>
    </div>
      </v-col>
        <v-col align="center" justify="center" cols="12" xl="2" lg="2" md="2" sm="12" xs="12"></v-col>
      </v-row>

      <!-- <v-row class="ma-2" justify="center" >
          <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <h4 class="justify-center font-weight-regular mt-n4">{{this.lg_header_contract.detail_first_submit}}</h4>
          </v-col>
    </v-row> -->
     
      <v-card-actions :class="$vuetify.breakpoint.xs ? 'justify-center' : 'justify-start'">
        <!-- <input type="submit" :value="this.lg_header_contract.submit" /> -->
         <!-- v-bind:style="{ minWidth: 'auto', backgroundColor: '#04182D' }" -->
          <!-- rounded-pill -->
        <v-btn
                type="submit"
                class="mb-1 white--text slide-btn"
                width="250"
                height="40" 
                :style="{ minWidth: 'auto' }"
                outlined
              >
              {{
              lg_header_contract.submit
            }}
              </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
      </v-col>
      <v-col  class="order-1 order-md-2" align="left" cols="12" xl="4" lg="4" md="4" sm="12" xs="12" v-bind:style="{align:'left'}">
            <v-row justify="left" v-bind:style="{align:'left' }">
          <h1 class="display-6 fw-bold lh-1 mb-3" v-bind:style="{ color: '#000000',fontSize:'48px'}">
            {{ this.lg_header_contract.title }}
          </h1>

          <h2 v-bind:style="{ color: '#000000',fontWeight:'300 !important',align:'left' }">
            {{ this.lg_header_contract.title1 }}
          </h2>
           </v-row>

            <v-row class="mt-8">
            <h2  v-bind:style="{ color: '#000000',fontWeight:'500 !important',align:'left',fontSize:'22px' }">
            <v-icon large color="black">mdi-email</v-icon> {{ this.lg_header_contract.email_contact }}
          </h2>
          </v-row>
           <v-row class="mt-4">
                <h2  class="ml-6"  v-bind:style="{ color: '#000000',fontWeight:'300 !important',align:'left',fontSize:'16px' }">
           {{ this.lg_header_contract.email }}
          </h2>
           </v-row>

            <v-row class="mt-8">
            <h2  v-bind:style="{ color: '#000000',fontWeight:'500 !important',align:'left',fontSize:'22px' }">
            <v-icon large color="black">mdi-phone</v-icon> {{ this.lg_header_contract.phone }}
          </h2>
          </v-row>
           <v-row class="mt-4">
                <h2  class="ml-6"  v-bind:style="{ color: '#000000',fontWeight:'300 !important',align:'left',fontSize:'16px' }">
           {{ this.lg_header_contract.tel }}
          </h2>
           </v-row>

            <v-row class="mt-8">
            <h2  v-bind:style="{ color: '#000000',fontWeight:'500 !important',align:'left',fontSize:'22px' }">
            <v-icon large color="black">mdi-map-marker</v-icon> {{ this.lg_header_contract.address }}
          </h2>
          </v-row>
           <v-row class="mt-4">
                <h2  class="ml-6"  v-bind:style="{ color: '#000000',fontWeight:'300 !important',align:'left',fontSize:'16px' }">
           {{ this.lg_header_contract.address_details }}
          </h2>
           </v-row>
      </v-col>
    </v-row>
   
    
    
    <!-- Privacy Dialog -->
    <v-dialog v-if="showpop" v-model="privacyDlg" :max-width="maxwidthdialog">
      <v-card v-bind:style="{ padding: '1rem' }">
        <v-img height="200" contain src="../assets/privacypolicy4.png"></v-img>

        <v-card-title primary-title class="justify-center">
          {{ this.lg_policy.privacy_consent }}</v-card-title
        >

        <v-divider class="mx-4"></v-divider>

        <v-card-text>
          <div class="mt-3">
            {{ this.lg_policy.text1 }}
          </div>
          <div class="mt-3">
            {{ this.lg_policy.text2 }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :small="buttonsmall"
            outlined
            color="success"
            text
            @click="onclickPrivacyDlg()"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            {{ this.lg_policy.accept }}
          </v-btn>

          <v-btn
            :small="buttonsmall"
            outlined
            color="error"
            text
            @click="onclickNonPrivacyDlg()"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            {{ this.lg_policy.notaccept }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <LoadingDialog></LoadingDialog>
</v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { feature } from "../services/constants";
import { lg_header_contract } from "./language/lg_header_contract.js";
import { lg_header_feature } from "./language/lg_header_feature.js";

export default {
  name: "Contact",
  data: () => ({
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    width: 420,
    width_emp: 600,
    text_fontsize: 30,
    privacy_sta: "false",
    privacyDlg: false,
          form: {
        name: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        requestType: "",
        message: "",
        email_to: "contact@dcm.co.th",
      },
      valid: false,
      isRequirednameRules: true,
      isRequiredemailRules:true,
      isRequiredphoneRules:true,
      isRequiredmessageRules:true,
      nameRules:[],
      emailRules:[],
      phoneRules:[],
      messageRules:[],
  }),
   async beforeCreate() {
      this.$store.state.page_reload = false;

      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_contract = lg_header_contract.lg_header_contract_th
        : this.lg_header_contract = lg_header_contract.lg_header_contract_en;

        localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_header_feature = lg_header_feature.lg_header_feature_th)
      : (this.lg_header_feature = lg_header_feature.lg_header_feature_en);

        // console.log("lg_login: " + JSON.stringify(this.lg_login));

       
    },
    async mounted() {
      this.$store.state.loadFooter = true;
            const userId = localStorage.getItem(server.USER_ID);
       if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }
      var toggler = document.getElementsByClassName("caret");
const removeAllactiveclass = (indexnotremove)=> {
  for (var i = 0; i < toggler.length; i++) {
    if(i !== indexnotremove){
      document.querySelectorAll(".nested")[i].classList.remove("active");
      toggler[i].classList.remove("caret-down");
    }
}
}

const indexIn = (selector, element)=> {
  for (var i = 0; i < selector.length; ++i)
    if (toggler[i] === element) return i;
  return -1;
}

for (var i = 0; i < toggler.length; i++) {
  toggler[i].addEventListener("click", function() {
    removeAllactiveclass(parseInt(indexIn("." + this.classList[i], this)));

     if(!document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.contains("active")){
      document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.add("active");
    }else{
      document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.remove("active");
    }

    if(toggler[parseInt(indexIn("." + this.classList[i], this))].classList.contains("caret-down")){
      toggler[parseInt(indexIn("." + this.classList[i], this))].classList.remove("caret-down");
    }else{
      toggler[parseInt(indexIn("." + this.classList[i], this))].classList.add("caret-down");
    }
  });
}

             this.nameRules = this.isRequirednameRules ? [v => !!v || `${this.lg_header_contract.rules_name}`]: [];
             this.emailRules = this.isRequiredemailRules ?[
        (v1) =>
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            v1
          ) || this.lg_header_contract.rules_email,
      ]: [];
            this.phoneRules = this.isRequiredphoneRules ?[(v1) => /^\d{10}$/.test(v1) || this.lg_header_contract.rules_phone]: [];
            this.messageRules = this.isRequiredmessageRules ?[v => !!v || `${this.lg_header_contract.rules_message}`]: [];

    
    },
         watch: {
    isRequirednameRules(val) {
      if (val) {
        this.nameRules = [v => !!v || `${this.lg_header_contract.rules_name}`];
      } else {
        this.nameRules = [];
      }
    },
      isRequiredemailRules(val) {
      if (val) {
        this.emailRules = [
        (v1) =>
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            v1
          ) || this.lg_header_contract.rules_email,
      ];
      } else {
        this.emailRules = [];
      }
    },
     isRequiredphoneRules(val) {
      if (val) {
        this.phoneRules = [(v1) => /^\d{10}$/.test(v1) || this.lg_header_contract.rules_phone];
      } else {
        this.phoneRules = [];
      }
    },
     isRequiredmessageRules(val) {
      if (val) {
        this.messageRules = [v => !!v || `${this.lg_header_contract.rules_message}`];
      } else {
        this.messageRules = [];
      }
    },
  },
    computed: {
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "75%";
        case "sm":
          return "76%";
        case "md":
          return "60%";
        case "lg":
          return "40%";
        case "xl":
          return "40%";
      }
    },
    widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300";
        case "sm":
          return "400";
        case "md":
          return "400";
        case "lg":
          return "400";
        case "xl":
          return "400";
      }
      },
    },
    methods: {
      onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
    async sendEmail(e) {
     
       
        if (this.$refs.form.validate()) {
           this.$swal.showLoading();
           console.log(this.form);
        // return;
      try {
        // this.form.name =  `${this.form.firstname} ${this.form.lastname}`;
        this.$swal.showLoading();
        const response = await api.onUserSendRequestContact(this.form);
        this.$swal.close();
        if (response && response.data && response.data.status === "success") {
          this.$swal.fire("Success", response.data.message, "success");
          // Reset form field
          this.form.name = "";
          this.form.firstname = "";
          this.form.lastname = "";
          this.form.email = "";
          this.form.phone = "";
          this.form.requestType = "";
          this.form.message = "";
        } else {
          this.$swal.fire("Error", response.data.message, "error");
        }
      } catch (error) {
        console.log({ error });
        this.$swal.close();
        this.$swal.fire("Error", error.message, "error");
      }
    }
    },
    },
};
</script>


<style scoped>
/*
@media only screen and (max-width: 600px) {
  .v-card{
    margin-top:40px;
     margin-bottom:40px;
      margin-right:40px;
       margin-left:40px;
}
}
*/
@media only screen and (max-width: 320px)  {
  .v-application {
    margin-top:-50px;
  }
  /* .homemain{
    height:80vh !important;
  }
  .homefeature{
    height:150vh !important;
  }
  .homepricing{
    height:90vh !important;
  }
  .homegettotouch{
    height:100vh !important;
  } */
}
  @media only screen and (min-width: 320px) and (max-width: 599px)  {
  /* .mainpage-container {
    margin-top:-150px;
  } */
  .v-application {
    margin-top:-50px;
    /* height: 110% !important; */
  }
  /* .homemain{
    height:75vh !important;
  }
  .homefeature{
    height:130vh !important;
  }
  .homepricing{
    height:70vh !important;
  }
  .homegettotouch{
    height:90vh !important;
  } */
}

/* @media (max-width: 959px) {
  .homefeature{
    height: 40% !important;
  }
} */

@media only screen and (min-width: 600px) and (max-width: 960px)  {
  .homefeature{
    height:80vh !important;
  }
}

@media (min-width: 960px) {
  .mainpage-container {
    margin-top: 3rem
  }
}
.custom-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.custom-label {
  font-size: 16px;
  color: #668199;
  /* font-weight: 400; */
   text-align: left;
}

.required-star {
  color: #668199;
  margin-left: 2px;
}

/* ซ่อน label ภายใน v-text-field ออก เพราะใช้ label ด้านนอกแทน */
.custom-input >>> .v-label {
  display: none;
}

.custom-input >>> fieldset {
  border-color: #d0d0d0;
  border-radius: 8px;
}

.custom-input >>> .v-input__slot {
  min-height: 40px;
}

</style>
